<script>
    import Compass from '../Compass/Compass.svelte';
    import Selection from '../Selection/Selection.svelte';
    import TransitionIndicator from '../TransitionIndicator/TransitionIndicator.svelte';
    import Ad from '../Ad/Ad.svelte';
    import {onMount, afterUpdate} from 'svelte';
    import {survey, page} from '../../stores.js';
    import {db} from '../../firebase';
    import {sendEvent} from '../../tracking.js';

    const pageTransitionTimeout = 5000;
    let pageChangeTimeoutId;
    let isPageTransitionRunning = false;
    let pageId = false;

    export let surveyId;

    function loadPage(id) {
        page.load(id);
        pageId = id;
    }

    function changePage(nextPageId, force) {
        const timeOut = force ? 0 : pageTransitionTimeout;

        // early return if there is no next page
        if (nextPageId === null || nextPageId === '' || nextPageId === 'null' || typeof nextPageId === 'undefined') {
            return;
        }

        if (force || pageChangeTimeoutId) {
            clearTimeout(pageChangeTimeoutId);
            isPageTransitionRunning = false;
        }

        setTimeout(() => {
            isPageTransitionRunning = !force;
        }, 10);

        pageChangeTimeoutId = setTimeout(() => {
            loadPage(nextPageId);
            pageChangeTimeoutId = null;
            isPageTransitionRunning = false;
        }, timeOut);
    }

    function writeValue(pageId, data) {
        const now = new Date();
        const obj = {
            timestamp: now,
            result: data,
            version: '1',
        };

        db.collection('pages').doc(pageId).collection('results').add(obj);
    }

    const unsubscribeSurvey = survey.subscribe(value => {
        if (typeof value.firstpage !== 'undefined') {
            pageId = value.firstpage.replace(/pages\//, '');
            loadPage(pageId);
            unsubscribeSurvey();
        }
    });

    function setup() {
        if (typeof surveyId !== 'undefined') {
            survey.load(surveyId);

            sendEvent('widgetLoaded', {
                widgetId: surveyId,
            });
        }
    }

    function callIframeSizeAdjustment() {
        if(window.parentIFrame && typeof window.parentIFrame.sendMessage === 'function') {
            window.parentIFrame.sendMessage({
                name: `cr__afterUpdate`,
            });
        } else {
            setTimeout(callIframeSizeAdjustment, 500);
        }
    }

    onMount(setup);

    afterUpdate(callIframeSizeAdjustment);
</script>

<style src="App.scss"></style>
<main style={$survey.color ? `--primary: ${$survey.color}` : ''} class={$survey.style ? `style--${$survey.style}` : ''}>
    <!--    <pre><code>{surveyId}</code></pre>-->
    <!--    <hr/>-->
    <!--    <pre><code>{JSON.stringify($survey, null, 4)}</code></pre>-->
    <!--    <hr/>-->
    <!--    <pre><code>{JSON.stringify(pageId, null, 4)}</code></pre>-->
    <!--    <hr/>-->
    <!--    <pre><code>{JSON.stringify($page, null, 4)}</code></pre>-->
    <!--    <hr/>-->

    {#if $page.type === 'compass'}
        <Compass config={$page}
                 pageId={pageId}
                 writeValue={writeValue}
                 changePage={changePage}
        />
    {/if}
    {#if $page.type === 'selection'}
        <Selection config={$page}
                   pageId={pageId}
                   writeValue={writeValue}
                   changePage={changePage}
        />
    {/if}
    {#if $page.type === 'ad'}
        <Ad content={$page.content}
            config={$page}
            changePage={changePage}
        />
    {/if}

    {#if isPageTransitionRunning}
        <TransitionIndicator time={pageTransitionTimeout}
        />
    {/if}
</main>
